import { render, staticRenderFns } from "./UserAuthentication.vue?vue&type=template&id=c5a57a10"
import script from "./UserAuthentication.vue?vue&type=script&lang=js"
export * from "./UserAuthentication.vue?vue&type=script&lang=js"
import style0 from "./UserAuthentication.vue?vue&type=style&index=0&id=c5a57a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports